import { useFrame, useTranslations } from '~/services/umbraco/hooks';
import { Button, LinkButton } from '~/shared/components/Button';
import { useCurrency } from '~/shared/hooks';
import { theme } from '~/theme';
import { Buttons, Column, Row, Wrapper } from './styled';
import { useSession } from 'next-auth/react';
import { useBasket } from '~/services/shop/hooks/basket';

type Props = { onContinueShoppingClick: () => void };

export const Footer = ({ onContinueShoppingClick }: Props) => {
    const { status } = useSession();
    const { data: basket } = useBasket();
    const { data: frame } = useFrame();
    const { translate } = useTranslations();
    const formatCurrency = useCurrency();

    return (
        <Wrapper>
            {status === 'unauthenticated' ? (
                <>
                    <Row isSubtotal>
                        <Column isSubtotal>{translate('basket.summary.subtotal')}</Column>
                        <Column isSubtotal>
                            {formatCurrency(basket?.subTotal.priceInclVat || 0)}
                        </Column>
                    </Row>

                    {basket?.packagingAmount?.priceInclVat ? (
                        <Row>
                            <Column>{translate('basket.pledgedPackaging')}</Column>
                            <Column>
                                {formatCurrency(basket?.packagingAmount.priceInclVat || 0)}
                            </Column>
                        </Row>
                    ) : null}

                    <Row>
                        <Column isDelivery>{translate('basket.delivery')}</Column>
                        <Column>
                            {basket?.freightPrice?.priceInclVat
                                ? formatCurrency(basket?.freightPrice?.priceInclVat)
                                : translate('generic.price.free')}
                        </Column>
                    </Row>
                </>
            ) : null}

            <Buttons>
                <LinkButton href={frame?.staticLinks?.basketPage?.url || '/'}>
                    {translate('basket.proceedToBasket')}
                </LinkButton>

                <Button
                    variant="stroke"
                    color={theme.colors.nightBlack}
                    onClick={onContinueShoppingClick}
                >
                    {translate('basket.continueShopping')}
                </Button>
            </Buttons>
        </Wrapper>
    );
};
